import GlobalConfig from './conf';
import XEUtils from 'xe-utils';
import DomZIndex from 'dom-zindex';
/**
 * 全局参数设置
 */
export var config = function (options) {
    if (options && options.zIndex) {
        DomZIndex.setCurrent(options.zIndex);
    }
    return XEUtils.merge(GlobalConfig, options);
};
